import { Inject, Injectable } from "@angular/core";
import { CaseData } from "@vp/models";
import { EPIC_INGEST_USER } from "@vp/shared/tokens";

@Injectable({ providedIn: "root" })
export class EpicService {
  constructor(@Inject(EPIC_INGEST_USER) private readonly epicUserId: string) {}

  isCreatedByEpicUser(caseData: CaseData): boolean {
    return caseData.createdBy === this.epicUserId;
  }
}
